import {
  DesignClass,
  ExportComponentType,
  ExportNodeType,
  ObjectClass
} from '@app/types';

type MapType = (
  Record<
    Exclude<DesignClass, DesignClass.condition | DesignClass.link>,
    ExportComponentType
  >
  &
  Record<
    Exclude<ObjectClass, ObjectClass.base | ObjectClass.note>,
    ExportNodeType
  >
);

/** Map D2 item types to PE item types. */
export const designClassD2ToPe = {
  [ObjectClass.banner]: ExportNodeType.banner,
  [ObjectClass.begin]: ExportNodeType.begin,
  [ObjectClass.custom]: ExportNodeType.custom,
  [ObjectClass.data]: ExportNodeType.data,
  [ObjectClass.dataAccessCompletion]: ExportNodeType.dataAccessCompletion,
  [ObjectClass.dtmf]: ExportNodeType.dtmf,
  [ObjectClass.exit]: ExportNodeType.exit,
  [ObjectClass.flushPrompts]: ExportNodeType.flushPrompts,
  [ObjectClass.humanAssistedResolution]: ExportNodeType.humanAssistedResolution,
  [ObjectClass.input]: ExportNodeType.input,
  [DesignClass.intent]: ExportComponentType.intent,
  [ObjectClass.loopEscalation]: ExportNodeType.loopEscalation,
  [DesignClass.module]: ExportComponentType.module,
  [ObjectClass.moduleReference]: ExportNodeType.moduleReference,
  [ObjectClass.oasys]: ExportNodeType.oasys,
  [ObjectClass.playSavedPrompt]: ExportNodeType.playSavedPrompt,
  [ObjectClass.prompt]: ExportNodeType.prompt,
  [ObjectClass.promptReference]: ExportNodeType.promptReference,
  [ObjectClass.report]: ExportNodeType.report,
  [ObjectClass.richText]: ExportNodeType.richText,
  [ObjectClass.savePrompt]: ExportNodeType.savePrompt,
  [ObjectClass.session]: ExportNodeType.session,
  [ObjectClass.sessionCompletion]: ExportNodeType.sessionCompletion,
  [ObjectClass.tab]: ExportNodeType.tab,
  [ObjectClass.taskOrchestration]: ExportNodeType.taskOrchestration,
  [ObjectClass.trustedResponse]: ExportNodeType.trustedResponse,
  [DesignClass.variable]: ExportComponentType.variable,
  [ObjectClass.vxmlRender]: ExportNodeType.vxmlRender,
  [ObjectClass.withFiller]: ExportNodeType.withFiller
} satisfies MapType;
